export enum PageSubscriptionPlansActionTypes {
  GET_PAGE_SUBSCRIPTION_PLANS_REQUEST = 'page-subscription-plans/GET_PAGE_SUBSCRIPTION_PLANS_REQUEST',
  GET_PAGE_SUBSCRIPTION_PLANS_SUCCESS = 'page-subscription-plans/GET_PAGE_SUBSCRIPTION_PLANS_SUCCESS',
  GET_PAGE_SUBSCRIPTION_PLANS_ERROR = 'page-subscription-plans/GET_PAGE_SUBSCRIPTION_PLANS_ERROR',
  PUT_PAGE_SUBSCRIPTION_PLANS_REQUEST = 'page-subscription-plans/PUT_PAGE_SUBSCRIPTION_PLANS_REQUEST',
  PUT_PAGE_SUBSCRIPTION_PLANS_SUCCESS = 'page-subscription-plans/PUT_PAGE_SUBSCRIPTION_PLANS_SUCCESS',
  PUT_PAGE_SUBSCRIPTION_PLANS_ERROR = 'page-subscription-plans/PUT_PAGE_SUBSCRIPTION_PLANS_ERROR',
}
